import HttpRequest from './request'
import { checkRef, apiFetch } from '@/api/fetcher'
import env from '@/env'
import './fileDownLoad'
// 服务请求地址
export const BASE_URL = env.baseUrl + '/lanqiao-tms-app'
export const LQ_BASE_URL = env.lqBaseUrl

// 服务网关映射
export const GatewayMap = {
  personnelAdministration: '/personnelAdministration',
  tmsApi: '/tmsApi',
  common: '/Common',
  notice: '/Notice',
  quickFindResult: '/QuickFindResult',
  parmSetting: '/parmsetting',
  loadInfo: '/LoadInfo',
  transportResources: '/TransportResources',
  biChart: '/BIchart',
  home: '/Home',
  publicData: '/PublicData',
  sysmana: '/sysmana',
  sysMana: '/sysMana',
  checkImg: '/CheckImg',
  smsPlatform: '/SMSPlatform',
  billing: '/Billing',
  customerProfiles: '/CustomerProfiles',
  vehicleOilCard: '/VehicleOilCard',
  customerInformationTemplate: '/CustomerInformationTemplate',
  settlement: '/Settlement',
  vehicleXinghao: '/VehicleXinghao',
  claimsSettlement: '/ClaimsSettlement',
  qualityManage: '/QualityManage',
  getModifyDataOne: '/GetModifyDataOne',
  deliveryRecord: '/DeliveryRecord',
  deliveryRecordVerifyAccend: '/VerifyAccend',
  deliveryRecordCancelVerifyAccend: '/CancelVerifyAccend',
  PersonnelAdministration: '/PersonnelAdministration',
  paymentWelfare: '/paymentWelfare',
  courier: '/Courier',
  sendPack_SB: '/SendPack_SB',
  wTTX: '/WTTX',
  myAccount: '/MyAccount',
  myaccount: '/myaccount',
  getModifyDataTwo: '/GetModifyDataTwo',
  priceSystem: '/priceSystem',
  fdpz: '/fdpz',
  acceptanceOfBill2: '/AcceptanceOfBill2',
  mybSupplyManagement: '/MybSupplyManagement',
  zzjg: '/zzjg',
  rptmana: '/rptmana',
  rptMana: '/rptMana',
  pinchebao: '/pinchebao',
  permissiongroup: '/permissiongroup',
  czy: '/czy',
  InventoryManagement: '/InventoryManagement',
  toggleSite: '/toggleSite',
  BindingEquipment: '/BindingEquipment',
  MyAccount: '/MyAccount',
  baseSetting: '/baseSetting',
  loadinfo: '/loadinfo',
  waybillImport: '/waybillImport',
  ImportTemplate: '/ImportTemplate',
  GoodsTrackingTemplate: '/GoodsTrackingTemplate',
  WarehouseManagement: '/WarehouseManagement',
  ImportWarehouse: '/ImportWarehouse',
  DataDictionary: '/DataDictionary',
  BillingCustom: '/BillingCustom',
  AreaData: '/AreaData',
  WeixinCoupon: '/WeixinCoupon',
  WXAccount: '/WXAccount',
  NewInventoryManagement: '/NewInventoryManagement'
}

// 应用扩展
export const personnelAdministrationUrl =
  BASE_URL + GatewayMap.personnelAdministration
export const tmsApiUrl = BASE_URL + GatewayMap.tmsApi
export const commonUrl = LQ_BASE_URL + GatewayMap.common
export const noticeUrl = LQ_BASE_URL + GatewayMap.notice
export const quickFindResultUrl = LQ_BASE_URL + GatewayMap.quickFindResult
export const parmSettingUrl = LQ_BASE_URL + GatewayMap.parmSetting
export const loadInfoUrl = LQ_BASE_URL + GatewayMap.loadInfo
export const transportResourcesUrl = LQ_BASE_URL + GatewayMap.transportResources
export const biChartUrl = LQ_BASE_URL + GatewayMap.biChart
export const homeUrl = LQ_BASE_URL + GatewayMap.home
export const publicDataUrl = LQ_BASE_URL + GatewayMap.publicData
export const sysManaUrl = LQ_BASE_URL + GatewayMap.sysMana
export const sysmanaUrl = LQ_BASE_URL + GatewayMap.sysmana
export const checkImgUrl = LQ_BASE_URL + GatewayMap.checkImg
export const smsPlatformUrl = LQ_BASE_URL + GatewayMap.smsPlatform
export const billingUrl = LQ_BASE_URL + GatewayMap.billing
export const customerProfilesUrl = LQ_BASE_URL + GatewayMap.customerProfiles
export const vehicleOilCardUrl = LQ_BASE_URL + GatewayMap.vehicleOilCard
export const customerInformationTemplateUrl =
  LQ_BASE_URL + GatewayMap.customerInformationTemplate
export const settlementUrl = LQ_BASE_URL + GatewayMap.settlement
export const vehicleXinghaoUrl = LQ_BASE_URL + GatewayMap.vehicleXinghao
export const claimsSettlementUrl = LQ_BASE_URL + GatewayMap.claimsSettlement
export const qualityManageUrl = LQ_BASE_URL + GatewayMap.qualityManage
export const getModifyDataOneUrl = LQ_BASE_URL + GatewayMap.getModifyDataOne
export const deliveryRecordUrl = LQ_BASE_URL + GatewayMap.deliveryRecord
export const deliveryRecordVerifyAccendUrl = LQ_BASE_URL + GatewayMap.deliveryRecordVerifyAccend
export const deliveryRecordCancelVerifyAccendUrl = LQ_BASE_URL + GatewayMap.deliveryRecordCancelVerifyAccend
export const PersonnelAdministrationUrl =
  LQ_BASE_URL + GatewayMap.PersonnelAdministration
export const paymentWelfareUrl = LQ_BASE_URL + GatewayMap.paymentWelfare
export const courierUrl = LQ_BASE_URL + GatewayMap.courier
export const sendPack_SBUrl = LQ_BASE_URL + GatewayMap.sendPack_SB
export const wTTXUrl = LQ_BASE_URL + GatewayMap.wTTX
export const myAccountUrl = LQ_BASE_URL + GatewayMap.myAccount
export const myaccountUrl = LQ_BASE_URL + GatewayMap.myaccount
export const getModifyDataTwoUrl = LQ_BASE_URL + GatewayMap.getModifyDataTwo
export const waybillImportUrl = LQ_BASE_URL + GatewayMap.waybillImport
export const priceSystemUrl = LQ_BASE_URL + GatewayMap.priceSystem
export const fdpzUrl = LQ_BASE_URL + GatewayMap.fdpz
export const acceptanceOfBill2Url = LQ_BASE_URL + GatewayMap.acceptanceOfBill2
export const mybSupplyManagementUrl = LQ_BASE_URL + GatewayMap.mybSupplyManagement
export const zzjgUrl = LQ_BASE_URL + GatewayMap.zzjg
export const rptmanaUrl = LQ_BASE_URL + GatewayMap.rptmana
export const rptManaUrl = LQ_BASE_URL + GatewayMap.rptMana
export const pinchebaoUrl = LQ_BASE_URL + GatewayMap.pinchebao
export const permissiongroupUrl = LQ_BASE_URL + GatewayMap.permissiongroup
export const czyUrl = LQ_BASE_URL + GatewayMap.czy
export const InventoryManagementUrl =
  LQ_BASE_URL + GatewayMap.InventoryManagement
export const toggleSiteUrl = LQ_BASE_URL + GatewayMap.toggleSite
export const BindingEquipmentUrl = LQ_BASE_URL + GatewayMap.BindingEquipment
export const MyAccountUrl = LQ_BASE_URL + GatewayMap.MyAccount
export const baseSettingUrl = LQ_BASE_URL + GatewayMap.baseSetting
export const loadinfoUrl = LQ_BASE_URL + GatewayMap.loadinfo
export const ImportTemplateUrl = LQ_BASE_URL + GatewayMap.ImportTemplate
export const GoodsTrackingTemplateUrl =
  LQ_BASE_URL + GatewayMap.GoodsTrackingTemplate
export const WarehouseManagementUrl =
  LQ_BASE_URL + GatewayMap.WarehouseManagement
export const ImportWarehouseUrl = LQ_BASE_URL + GatewayMap.ImportWarehouse
export const DataDictionaryUrl = LQ_BASE_URL + GatewayMap.DataDictionary
export const BillingCustomUrl = LQ_BASE_URL + GatewayMap.BillingCustom
export const AreaDataUrl = LQ_BASE_URL + GatewayMap.AreaData
export const WeixinCouponUrl = LQ_BASE_URL + GatewayMap.WeixinCoupon
export const WXAccountUrl = LQ_BASE_URL + GatewayMap.WXAccount
export const NewInventoryManagementUrl = LQ_BASE_URL + GatewayMap.NewInventoryManagement

// 应用扩展信息
export const personnelAdministration = new HttpRequest(
  personnelAdministrationUrl
)
export const tmsApi = new HttpRequest(tmsApiUrl)
export const common = new HttpRequest(commonUrl)
export const notice = new HttpRequest(noticeUrl)
export const quickFindResult = new HttpRequest(quickFindResultUrl)
export const parmSetting = new HttpRequest(parmSettingUrl)
export const loadInfo = new HttpRequest(loadInfoUrl)
export const transportResources = new HttpRequest(transportResourcesUrl)
export const biChart = new HttpRequest(biChartUrl)
export const home = new HttpRequest(homeUrl)
export const publicData = new HttpRequest(publicDataUrl)
export const sysMana = new HttpRequest(sysManaUrl)
export const sysmana = new HttpRequest(sysmanaUrl)
export const checkImg = new HttpRequest(checkImgUrl)
export const smsPlatform = new HttpRequest(smsPlatformUrl)
export const billing = new HttpRequest(billingUrl)
export const customerProfiles = new HttpRequest(customerProfilesUrl)
export const vehicleOilCard = new HttpRequest(vehicleOilCardUrl)
export const customerInformationTemplate = new HttpRequest(
  customerInformationTemplateUrl
)
export const settlement = new HttpRequest(settlementUrl)
export const vehicleXinghao = new HttpRequest(vehicleXinghaoUrl)
export const claimsSettlement = new HttpRequest(claimsSettlementUrl)
export const qualityManage = new HttpRequest(qualityManageUrl)
export const getModifyDataOne = new HttpRequest(getModifyDataOneUrl)
export const deliveryRecordVerifyAccend = new HttpRequest(deliveryRecordVerifyAccendUrl)
export const deliveryRecordCancelVerifyAccend = new HttpRequest(deliveryRecordCancelVerifyAccendUrl)
export const PersonnelAdministration = new HttpRequest(
  PersonnelAdministrationUrl
)
export const paymentWelfare = new HttpRequest(paymentWelfareUrl)
export const courier = new HttpRequest(courierUrl)
export const sendPack_SB = new HttpRequest(sendPack_SBUrl)
export const wTTX = new HttpRequest(wTTXUrl)
export const deliveryRecord = new HttpRequest(deliveryRecordUrl)
export const myAccount = new HttpRequest(myAccountUrl)
export const myaccount = new HttpRequest(myaccountUrl)
export const getModifyDataTwo = new HttpRequest(getModifyDataTwoUrl)
export const waybillImport = new HttpRequest(waybillImportUrl)
export const priceSystem = new HttpRequest(priceSystemUrl)
export const fdpz = new HttpRequest(fdpzUrl)
export const acceptanceOfBill2 = new HttpRequest(acceptanceOfBill2Url)
export const mybSupplyManagement = new HttpRequest(mybSupplyManagementUrl)
export const zzjg = new HttpRequest(zzjgUrl)
export const rptmana = new HttpRequest(rptmanaUrl)
export const rptMana = new HttpRequest(rptManaUrl)
export const pinchebao = new HttpRequest(pinchebaoUrl)
export const permissiongroup = new HttpRequest(permissiongroupUrl)
export const czy = new HttpRequest(czyUrl)
export const InventoryManagement = new HttpRequest(InventoryManagementUrl)
export const toggleSite = new HttpRequest(toggleSiteUrl)
export const BindingEquipment = new HttpRequest(BindingEquipmentUrl)
export const MyAccount = new HttpRequest(MyAccountUrl)
export const baseSetting = new HttpRequest(baseSettingUrl)
export const loadinfo = new HttpRequest(loadinfoUrl)
export const ImportTemplate = new HttpRequest(ImportTemplateUrl)
export const GoodsTrackingTemplate = new HttpRequest(GoodsTrackingTemplateUrl)
export const WarehouseManagement = new HttpRequest(WarehouseManagementUrl)
export const ImportWarehouse = new HttpRequest(ImportWarehouseUrl)
export const DataDictionary = new HttpRequest(DataDictionaryUrl)
export const BillingCustom = new HttpRequest(BillingCustomUrl)
export const AreaData = new HttpRequest(AreaDataUrl)
export const WeixinCoupon = new HttpRequest(WeixinCouponUrl)
export const WXAccount = new HttpRequest(WXAccountUrl)
export const NewInventoryManagement = new HttpRequest(NewInventoryManagementUrl)

window.__lq_apiRef = checkRef
window.__lq_fetch = apiFetch
